import variables from '../variables';

const typography = {
  fontFamily: variables.font.fontFamily.join(','),
  letterSpacing: '1.36px',
  h1: {
    fontFamily: variables.font.fontFamilySerif.join(','),
    color: variables.text.headerColor,
    fontSize: 36,
    fontWeight: 300,
  },
  h2: {
    fontSize: 24,
    fontFamily: variables.font.fontFamilySerif.join(','),
    color: variables.text.headerColor,
    fontWeight: 300,
  },
  h3: {
    fontSize: 20,
    fontFamily: variables.font.fontFamilySerif.join(','),
    color: variables.text.headerColor,
    fontWeight: 300,
  },
  h4: {
    fontSize: 18,
    fontFamily: variables.font.fontFamilySerif.join(','),
    color: variables.text.headerColor,
    fontWeight: 300,
  },
  h5: {
    fontSize: 16,
    fontFamily: variables.font.fontFamilySerif.join(','),
    color: variables.text.headerColor,
    fontWeight: 300,
  },
  useNextVariants: true,
  body1: {
    fontSize: 16,
    fontFamily: variables.font.fontFamily.join(','),
  },
  body2: {
    fontSize: 16,
    fontFamily: variables.font.fontFamily.join(','),
    letterSpacing: '1.36px',
  },
  subtitle1: {
    fontSize: 16,
    fontFamily: variables.font.fontFamily.join(','),
    margin: '20px 0',
  },
  caption: {
    fontSize: 16,
  },
};

export default typography;
